import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button, Card, Table } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';
import { commonSearch } from 'store/commonSlice';
import WhatsAppGroupSelector from './WhatsAppGroupSelector';

const getColumns = (handleEditGroup) => [
	{
		title: 'Group Name',
		dataIndex: 'group_name',
		key: 'group_name',
	},
	{
		title: 'Client Name',
		dataIndex: 'client_name',
		key: 'client',
	},
	{
		title: 'Update Frequency',
		dataIndex: 'update_frequency',
		key: 'frequency',
		render: (val) => `${val} minutes`,
	},
	{
		title: 'Created On',
		dataIndex: 'created_at',
		key: 'created_on',
	},
	{
		title: 'Actions',
		dataIndex: 'id',
		key: 'actions',
		render: (_, record) => (
			<Button icon={<EditOutlined />} type="text" onClick={() => handleEditGroup(record)} />
		),
	},
];

export default function GroupManager({
	connectionStatus,
	refreshData,
	setRefreshData,
	searchGroup,
}) {
	const [modalOpen, setModalOpen] = useState(false);
	const [editRecord, setEditRecord] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [groupData, setGroupData] = useState([]);
	const dispatch = useDispatch();

	const paginationLimit = 10;

	const updateCurrentPage = (pageNo) => {
		setCurrentPage(pageNo);
	};

	useEffect(() => {
		if (refreshData || searchGroup !== undefined) {
			dispatch(
				commonSearch({
					search_type: 'whatsapp_group',
					group_name: searchGroup,
					limit: paginationLimit,
					offset: paginationLimit * (currentPage - 1),
				})
			).then((res) => {
				setGroupData(res.rows);
				setRefreshData(false);
			});
		}
	}, [dispatch, refreshData, searchGroup, currentPage]);

	const handleEditGroup = (record) => {
		setModalOpen(true);
		setEditRecord(record);
	};

	const resetEditRecord = () => {
		setEditRecord(null);
	};

	return (
		<>
			<Card
				title="WhatsApp Groups"
				size="small"
				style={{ marginTop: 24 }}
				extra={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={() => setModalOpen(true)}
						disabled={connectionStatus !== 'connected'}
					>
						Add Group
					</Button>
				}
			>
				<Table
					rowKey="id"
					columns={getColumns(handleEditGroup)}
					dataSource={groupData}
					pagination={{
						total: groupData?.meta?.count,
						showSizeChanger: false,
						current: Number(currentPage) || 1,
						pageSize: paginationLimit,
						position: ['bottomCenter'],
						simple: true,
						onChange: updateCurrentPage,
					}}
				/>
			</Card>

			<WhatsAppGroupSelector
				modalOpen={modalOpen}
				setOpen={setModalOpen}
				formData={editRecord}
				refresh={setRefreshData}
				resetRecord={resetEditRecord}
			/>
		</>
	);
}

GroupManager.propTypes = {
	connectionStatus: PropTypes.string,
	refreshData: PropTypes.bool,
	setRefreshData: PropTypes.func,
	searchGroup: PropTypes.string,
};
